import React from "react";
import { Chip } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

// Cada estado lleva color, fondo suave, ícono y un texto: nunca se comunica solo con el color.
// `fondo` y `texto` son claves de theme.palette.soft / theme.palette. El estado "info" usa el color primario
// (no `info`) porque #1F6FB2 sobre soft.primary da 4,43:1 y no llega a AA como texto.
const ESTADOS = {
  ok: { texto: "success", fondo: "success", Icono: CheckCircleOutlineIcon, label: "Al día" },
  aviso: { texto: "warning", fondo: "warning", Icono: WarningAmberIcon, label: "Por vencer" },
  mora: { texto: "error", fondo: "error", Icono: ErrorOutlineIcon, label: "En mora" },
  info: { texto: "primary", fondo: "primary", Icono: InfoOutlinedIcon, label: "Información" },
  neutro: { texto: null, fondo: null, Icono: RemoveCircleOutlineIcon, label: "Sin estado" },
};

/**
 * Etiqueta de estado con color semántico, fondo suave e ícono.
 *
 * @param {object} props
 * @param {"ok"|"aviso"|"mora"|"info"|"neutro"} [props.estado] Por defecto "neutro".
 * @param {React.ReactNode} [props.label] Texto visible; si falta, usa uno por defecto del estado.
 */
export const EstadoChip = ({ estado = "neutro", label }) => {
  const { texto, fondo, Icono, label: porDefecto } = ESTADOS[estado] ?? ESTADOS.neutro;

  return (
    <Chip
      size="small"
      icon={<Icono />}
      label={label ?? porDefecto}
      sx={(theme) => ({
        fontWeight: 700,
        // El neutro usa el texto secundario sobre el fondo de pantalla, con borde fino.
        backgroundColor: fondo
          ? theme.palette.soft?.[fondo]
          : theme.palette.background.default,
        color: texto ? theme.palette[texto].main : theme.palette.text.secondary,
        border: fondo ? "none" : `1px solid ${theme.palette.divider}`,
        "& .MuiChip-icon": { color: "inherit" },
      })}
    />
  );
};
